export function generateTestId(...args) {
    if (args.length === 0) {
        return '';
    }

    // join into a single string with hyphens and convert to lowercase
    return args
        .join('-')
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}
